module.exports = __webpack_public_path__ + "static/media/money_market_custom.b0070534.svg";